var ImageCropperModel = (function () {
    function ImageCropperModel() {
    }
    return ImageCropperModel;
}());
export { ImageCropperModel };
//# sourceMappingURL=imageCropperModel.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-cropper/src/model/imageCropperModel.js
// module id = 2055
// module chunks = 3